var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaLogotype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.222 38.845h-5.035l3.15-20.35h5.034l-3.15 20.35ZM41.744 17.684c-4.94 0-8.417 2.86-8.439 6.951-.04 3.018 2.49 4.695 4.384 5.7 1.935 1.03 2.593 1.7 2.593 2.617-.02 1.408-1.564 2.056-3.004 2.056-1.997 0-3.067-.334-4.693-1.117l-.658-.336-.7 4.717c1.173.58 3.334 1.096 5.578 1.118 5.248 0 8.665-2.817 8.705-7.176.02-2.392-1.317-4.225-4.198-5.722-1.75-.962-2.82-1.61-2.82-2.594.02-.894.905-1.81 2.88-1.81 1.626-.045 2.82.38 3.726.804l.452.224.68-4.538c-.986-.425-2.551-.894-4.486-.894Zm12.864 13.952c.438-1.17 2.124-5.694 2.124-5.694-.022.043.438-1.19.7-1.948l.372 1.753s1.008 4.871 1.227 5.889h-4.423Zm6.568-13.141H57.06c-1.27 0-2.233.367-2.781 1.688l-7.905 18.662h5.584l1.117-3.053h6.832c.153.715.635 3.053.635 3.053h4.928l-4.294-20.35Zm-43.306 0-4.924 13.891-.538-2.817c-.91-3.251-3.766-6.783-6.952-8.54l4.51 17.816h5.317l7.904-20.35H17.87Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.132 18.495H.092L0 18.898c7.051 1.657 11.72 5.65 13.64 10.45l-1.966-9.175c-.323-1.275-1.317-1.636-2.542-1.678Z",
    fill: "#BEBEBE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogotype);
export default __webpack_public_path__ + "static/media/visa-logotype.b73f34522571e8fba4bb1caab14ddc53.svg";
export { ForwardRef as ReactComponent };